import { AlertTriangle, BadgeCheck, LockKeyhole, ShieldCheck } from "lucide-react";
import shonanLogo from "@/assets/shonan-taxi-logo.jpg";
import expresswayLightTrails from "@/assets/japan-expressway-light-trails.png";

const policyItems = [
  "本公司品牌接机牌仅限湘南国際株式会社及经本公司正式授权的合作人员使用。",
  "未经授权，不得制作、使用或展示带有「湘南国際株式会社 / SHONAN INTERNATIONAL」名称、Logo 或其他可识别本公司品牌元素的接机牌。",
  "经授权代表本公司执行接机服务的司机及工作人员，须遵守本公司的服务及着装规范。",
];

export default function StandaloneSignboardPage() {
  return (
    <main className="relative min-h-screen overflow-hidden bg-[#06101d] px-4 py-8 text-white sm:px-6 sm:py-10">
      <img
        src={expresswayLightTrails}
        alt=""
        aria-hidden="true"
        className="absolute inset-0 h-full w-full object-cover object-center"
      />
      <div className="absolute inset-0 bg-[linear-gradient(180deg,rgba(2,8,18,0.72),rgba(2,8,18,0.36)_42%,rgba(2,8,18,0.88)),linear-gradient(90deg,rgba(2,8,18,0.82),rgba(2,8,18,0.35),rgba(2,8,18,0.82))]" />
      <div className="absolute inset-x-0 top-0 h-56 bg-[radial-gradient(circle_at_50%_0%,rgba(251,191,36,0.22),transparent_34rem)]" />

      <div className="relative z-10 mx-auto flex min-h-[calc(100vh-4rem)] w-full max-w-4xl flex-col items-center justify-center gap-7">
        <header className="flex flex-col items-center text-center">
          <div className="flex h-24 w-24 items-center justify-center overflow-hidden rounded-[1.35rem] border border-amber-200/55 bg-slate-950/55 shadow-[0_24px_70px_-30px_rgba(251,191,36,0.9)] backdrop-blur-md sm:h-28 sm:w-28">
            <img
              src={shonanLogo}
              alt="Shonan International TAXI-HIRE"
              className="h-full w-full object-cover"
            />
          </div>
          <p className="mt-5 text-[0.72rem] font-semibold uppercase tracking-[0.52em] text-amber-100/90 sm:text-xs">
            SHONAN INTERNATIONAL
          </p>
        </header>

        <section className="w-full overflow-hidden rounded-[1.7rem] border border-amber-100/24 bg-slate-950/62 shadow-[0_32px_110px_-34px_rgba(8,47,73,0.95)] backdrop-blur-xl">
          <div className="border-b border-amber-100/16 bg-white/[0.06] px-5 py-6 text-center sm:px-10 sm:py-8">
            <div className="mx-auto mb-4 flex h-14 w-14 items-center justify-center rounded-full border border-amber-200/40 bg-amber-300/12 text-amber-100">
              <AlertTriangle className="h-7 w-7" aria-hidden="true" />
            </div>
            <p className="text-sm font-semibold uppercase tracking-[0.28em] text-amber-100/80">
              Public Notice
            </p>
            <h1 className="mt-3 text-3xl font-semibold tracking-tight text-white sm:text-5xl">
              接机牌生成系统下线公告
            </h1>
            <p className="mx-auto mt-4 max-w-2xl text-sm leading-7 text-slate-200/82 sm:text-base">
              即日起停止公开提供接机牌（Signboard）在线生成功能。
            </p>
          </div>

          <div className="space-y-7 px-5 py-7 text-[0.95rem] leading-8 text-slate-100/88 sm:px-10 sm:py-9 sm:text-base">
            <p>感谢各合作伙伴一直以来对湘南国際株式会社的支持与配合。</p>

            <p>
              由于近期发现本公司接机牌（Signboard）生成系统存在
              <strong className="font-semibold text-amber-100">未经授权使用及不规范使用</strong>
              的情况，部分非本公司工作人员通过该系统生成带有本公司品牌标识的接机牌，并在实际接待过程中未按照本公司的服务标准执行，包括但不限于
              <strong className="font-semibold text-amber-100">未按要求穿着正式服装、服务形象不符合本公司规范</strong>
              等情况。
            </p>

            <p>
              上述行为容易使客户误认为相关人员代表湘南国際株式会社提供服务，并可能对本公司的品牌形象及服务信誉造成影响。
            </p>

            <div className="rounded-2xl border border-amber-200/26 bg-amber-200/10 px-5 py-5 text-amber-50 shadow-inner shadow-amber-950/20">
              <div className="flex items-start gap-3">
                <ShieldCheck className="mt-1 h-5 w-5 shrink-0 text-amber-100" aria-hidden="true" />
                <div>
                  <p className="font-semibold">因此，为加强品牌及服务质量管理，本公司决定：</p>
                  <p className="mt-2 text-xl font-semibold tracking-tight text-white">
                    即日起停止公开提供接机牌（Signboard）在线生成功能。
                  </p>
                </div>
              </div>
            </div>

            <div>
              <p className="mb-4 font-semibold text-white">今后：</p>
              <ul className="space-y-3">
                {policyItems.map((item) => (
                  <li key={item} className="flex gap-3 rounded-2xl border border-white/10 bg-white/[0.045] px-4 py-3">
                    <BadgeCheck className="mt-1 h-5 w-5 shrink-0 text-amber-100" aria-hidden="true" />
                    <span>{item}</span>
                  </li>
                ))}
              </ul>
            </div>

            <p>
              本次调整旨在确保每一位使用本公司品牌进行服务的工作人员均符合统一的服务标准，并保护客户及合作伙伴对湘南国際株式会社品牌的信任。
            </p>

            <p>给各位合作伙伴带来的不便，敬请谅解。</p>

            <footer className="flex flex-col gap-3 border-t border-white/12 pt-6 text-white sm:flex-row sm:items-end sm:justify-between">
              <div>
                <p className="text-lg font-semibold">湘南国際株式会社</p>
                <p className="text-sm font-semibold uppercase tracking-[0.26em] text-amber-100/80">
                  SHONAN INTERNATIONAL CO., LTD.
                </p>
              </div>
              <p className="flex items-center gap-2 text-sm text-slate-300/76">
                <LockKeyhole className="h-4 w-4 text-amber-100/75" aria-hidden="true" />
                Brand and service quality notice
              </p>
            </footer>
          </div>
        </section>
      </div>
    </main>
  );
}
